import RestAPI from '../../../components/Common/restApi';

export const indexLenders = (lender_names) =>
  RestAPI.getWithFormData('/alpha/consumer_lending/lenders', { ...lender_names });
